// @ts-nocheck

export type TicketListWithOwner = typeof TicketListWithOwner[keyof typeof TicketListWithOwner];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketListWithOwner = {
  true: 'true',
  false: 'false',
} as const;
